import { FormType } from 'common/components/QuickQuoteForm/types';

export const isCenterPage: boolean = !!document.querySelector('.space-right-buttons-outer');

export const openModal = async (formType: FormType, targetElement: HTMLElement): Promise<void> => {
  let spaceId;
  if (isCenterPage) {
    spaceId = (document.getElementById('space_id') as HTMLInputElement)?.value;
  } else {
    const parentElement = targetElement?.parentElement;

    spaceId = parentElement?.dataset?.spaceId;
  }
  const modalProperties = {
    formType,
    spaceId,
    targetElement,
  };

  const globalAny: any = global;
  globalAny.toggleReactModal({ isQuickQuoteModalOpen: true }, modalProperties);
};
